import { useCallback } from "react";

export interface TableFilterProps {
    filterTerm: string;
    setFilterTerm: (term: string) => void;
    visible: boolean;
}

export function TableFilter({ visible, filterTerm, setFilterTerm }: TableFilterProps) {
    const clearFilterTerm = useCallback(() => setFilterTerm(''), [setFilterTerm]);

    if (!visible) {
        return null;
    }

    return (
        <div className="input-group">
            <input type="text" className="form-control" placeholder="Filter" value={filterTerm} onChange={e => setFilterTerm(e.target.value)} />
            <button className="btn btn-outline-primary" onClick={clearFilterTerm}>X</button>
        </div>
    );
}
